import { render, staticRenderFns } from "./RecipeSection.vue?vue&type=template&id=06ed6f83&scoped=true"
import script from "./RecipeSection.vue?vue&type=script&lang=js"
export * from "./RecipeSection.vue?vue&type=script&lang=js"
import style0 from "./RecipeSection.vue?vue&type=style&index=0&id=06ed6f83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ed6f83",
  null
  
)

export default component.exports